export default __webpack_public_path__ + "static/media/theater-app-screengrab2.d9c215e4.png";